import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, ReduxFormHiddenInput, Button } from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalTagDelete extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { visible, isClicked, onDeleteTag, onToggleModal, selectedTag } = this.props;

    if (!selectedTag) {
      return null;
    }
    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-tagDelete-area', 'common-content')}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalTagDelete_1', defaultMessage: '태그 삭제' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalTagDelete_3', defaultMessage: '취 소' }))}
            </Button>
            <Button className={cx('gray-button')} disabled={isClicked} loading={isClicked} onClick={onDeleteTag}>
              {defineMessages(formatMessage({ id: 'ModalTagDelete_2', defaultMessage: '삭 제' }))}
            </Button>
          </div>
        }>
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ModalTagDelete_4',
              defaultMessage: '삭제한 태그는 복구할 수 없습니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ModalTagDelete_7',
              defaultMessage: '다음 태그를 삭제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>No</div>
                {selectedTag.get('tagNo')}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ModalTagDelete_5', defaultMessage: '태그명' }))}
                </div>
                {selectedTag.get('tagName')}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ModalTagDelete_6', defaultMessage: '등록일시' }))}
                </div>
                {common.timeFormatFromUTCEpoch(selectedTag.get('regEpoch'))}
              </List.Item>
            </List>
            <ReduxFormHiddenInput name="tagNo" />
            <ReduxFormHiddenInput name="tagName" />
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}
ModalTagDelete.propTypes = {
  visible: PropTypes.bool,
  onDeleteTag: PropTypes.func,
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      tagNo: !!props.selectedTag && props.selectedTag.get('tagNo'),
      tagName: !!props.selectedTag && props.selectedTag.get('tagName')
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({ form: 'formTagDelete', enableReinitialize: true })(injectIntl(ModalTagDelete))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalTagDelete.js